import Admin from "../Admin";
import React from "react";
import CardAdminMarketingCampaignGeneral from "../../../Component/Card/Admin/MarketingCampaign/CardAdminMarketingCampaignGeneral";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import MUILoadingButton from "@mui/lab/LoadingButton";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from '@mui/material/MenuItem';
import MUIListItemIcon from '@mui/material/ListItemIcon';
import MarketingCampaignService from "../../../Seating/Security/MarketingCampaignService/marketingCampaignService";
import Validator from "../../../Utility/Validator";
import MarketingCampaign from "../../../Utility/Crud/MarketingCampaign";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";

export default class AdminMarketingCampaignCreateEdit extends Admin {
    constructor(props) {
        super(props);

        this.state.marketingCampaign = {
            isActive: true,
        };
        this.state.isProcessing = false;
        this.state.isUpdate = !!props.match.params.id;
        this.state.confirmDialogOpen = false;
        this.state.validationIssues = {};
    }

    /**
     * Set the marketingCampaign in the state.
     */
    afterComponentDidMount() {
        const marketingCampaignId = this.props.match.params.id ? +this.props.match.params.id : null;
        if (marketingCampaignId !== null) {
            this.setState({
                marketingCampaign: this.context.marketingCampaignsIndexed[marketingCampaignId]
            });
        }
    }

    /**
     * Creates the marketingCampaign with the current properties in state.marketingCampaign.
     */
    async createMarketingCampaign() {
        this.setState({
            isProcessing: true,
        });

        return MarketingCampaignService.createMarketingCampaign(this.state.marketingCampaign)
            .then(marketingCampaign => {
                this.context.updateIndexed("marketingCampaignsIndexed", marketingCampaign);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Marketing Campaign created successfully!", { variant: "success" });
            })
            .catch((err) => {
                // JZ. We need to test and make sure that Sentry still captures
                // errors when we catch them in the application.
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error creating a new Marketing Campaign.", { variant: "error" });
                this.setState({
                    isProcessing: false,
                });
            });
    }

    /**
     * Updates the marketingCampaign with the current properties in state.marketingCampaign.
     */
    async updateMarketingCampaign() {
        this.setState({
            isProcessing: true,
        });

        return MarketingCampaignService.updateMarketingCampaign(this.state.marketingCampaign)
            .then(marketingCampaign => {
                this.context.updateIndexed("marketingCampaignsIndexed", marketingCampaign);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Marketing Campaign updated successfully!", { variant: "success" });
            })
            .catch(err => {
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error updating the Marketing Campaign.", { variant: "error" });
                this.setState({
                    isProcessing: false,
                });
            });
    }

    async deleteMarketingCampaign() {
        this.setState({
            isProcessing: true,
        });

        return MarketingCampaignService.deleteMarketingCampaign(this.state.marketingCampaign.id)
            .then(() => {
                this.context.deleteIndexed("marketingCampaignsIndexed", this.state.marketingCampaign.id);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Marketing Campaign deleted successfully!", { variant: "success" });
            })
            .catch((err) => {
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error deleting the Marketing Campaign.", { variant: "error" });
                this.setState({
                    confirmDialogOpen: false,
                });
            });

    }

    /**
     * Render the content.
     */
    renderContent() {
        const handleChange = (marketingCampaign) => {
            this.setState({
                marketingCampaign: {
                    ...this.state.marketingCampaign,
                    ...marketingCampaign
                },
            });
        };

        return (
            <>
                <CardAdminMarketingCampaignGeneral
                    marketingCampaign={this.state.marketingCampaign}
                    onChange={handleChange.bind(this)}
                    validationIssues={this.state.validationIssues}
                />
                <DialogConfirm
                    open={this.state.confirmDialogOpen}
                    onClose={() => this.setState({ confirmDialogOpen: false })}
                    onConfirm={() => this.deleteMarketingCampaign()}
                    text="Are you sure you want to delete this Marketing Campaign? This cannot be undone."
                    header="Delete Marketing Campaign"
                    loading={this.state.isProcessing}
                />
            </>
        );
    }

    /**
    * Renders the header.
    */
    renderHeader() {
        let title;
        let subtitle;
        const buttonText = this.state.isUpdate ? "Save" : "Create";

        if (!this.state.isUpdate) {
            title = "Create Marketing Campaign";
            subtitle = null;
        } else {
            title = "Edit Marketing Campaign";
            subtitle = (this.state.marketingCampaign && (MarketingCampaign.getDisplayName(this.state.marketingCampaign) + " • " + this.state.marketingCampaign.id));
        }

        const handleClickBack = () => {
            this.props.history.goBack();
        };

        const handleClickSave = () => {
            const validationIssues = Validator.validate(
                this.state.marketingCampaign,
                {
                    name: {
                        'required': true
                    },
                    description: {
                        'required': true
                    },
                    campaignTypeId: {
                        'required': true
                    }
                }
            );

            this.setState({
                validationIssues: validationIssues,
            });


            if (Object.keys(validationIssues).length > 0) {
                return NotistackEnqueueSnackbar("Please correct the displayed issues.", { variant: "error" });
            }

            if (Object.keys(validationIssues).length === 0) {
                if (this.state.isUpdate) {
                    this.updateMarketingCampaign();
                } else {
                    this.createMarketingCampaign();
                }
            }

        };

        const handleDelete = () => {
            this.setState({
                confirmDialogOpen: true,
            });
        };

        const buttons = [
            (<MUIButton onClick={handleClickBack}>Back</MUIButton>),
            (
                <MUILoadingButton
                    loading={this.state.isProcessing}
                    loadingPosition="start"
                    onClick={handleClickSave}
                    variant="contained"
                    startIcon={<MUISaveButton />}>
                    {buttonText}
                </MUILoadingButton>
            )
        ];

        if (this.state.isUpdate) {
            const menuItems = [
                (
                    <MUIMenuItem onClick={handleDelete}>
                        <MUIListItemIcon>
                            <MUIDeleteIcon fontSize="small" />
                        </MUIListItemIcon>
                        Delete
                    </MUIMenuItem>
                )
            ];
            buttons.push((<Menu menuItems={menuItems} />));
        }

        return (
            <PageHeader title={title} subtitle={subtitle} buttons={buttons} />
        );
    }
}
